<template>
  <section class="mega-vertical-spacing dashboard-safety">
    <h3 class="md-vertical-spacing heading-4">Trust &amp; Safety</h3>

    <div class="dashboard-safety__card">
      <div class="dashboard-safety__content">
        <h3 class="heading-5">{{ cardTitle }}</h3>
        <p class="body-2 xs-vertical-spacing">{{ cardDescription }}</p>
        <Button class="p-0" variant="text" :href="cardLink" target="_blank" rel="noopener" value="Learn more" />
      </div>

      <div class="dashboard-safety__image">
        <BackgroundChecksIllustration v-if="hasOpenJobs && hasApplications" :width="76" :height="76" />
        <IdVerificationIllustration v-else-if="hasOpenJobs && !hasApplications" :width="76" :height="76" />
        <SitterResponsesIllustration v-else :width="76" :height="76" />
      </div>
    </div>
  </section>
</template>

<script lang="ts">
// Components
import Button from '@/components/button/Button.vue';

// Icons
import BackgroundChecksIllustration from '@/graphics/illustrations/BackgroundChecksIllustration.vue';
import IdVerificationIllustration from '@/graphics/illustrations/IdVerificationIllustration.vue';
import SitterResponsesIllustration from '@/graphics/illustrations/SitterResponsesIllustration.vue';

export default {
  name: 'TrustSafetyModule',
  components: {
    // Components
    Button,

    // Icons
    BackgroundChecksIllustration,
    IdVerificationIllustration,
    SitterResponsesIllustration,
  },
  props: {
    accountType: {
      type: String,
      required: true,
    },
    jobs: {
      type: Array,
      required: true,
    },
  },
  computed: {
    openJobs(): Array<any> {
      return this.jobs.filter((job: any) => ['OPEN', 'JOB_STATUS_OPEN'].includes(job.node.status));
    },
    hasApplications(): boolean {
      if (!this.openJobs.length) return false;

      return this.openJobs.some((job: any) => job.node.applications.totalCount > 0);
    },
    hasOpenJobs(): boolean {
      return !!this.openJobs.length;
    },
    cardTitle(): string {
      if (this.hasOpenJobs && !this.hasApplications) {
        return 'Screening your candidates';
      }

      if (this.hasOpenJobs && this.hasApplications) {
        return 'Background checks';
      }

      return 'The Trust & Safety Center';
    },
    cardDescription(): string {
      if (this.hasOpenJobs && !this.hasApplications && this.accountType === 'basic') {
        return 'Important info to help you get started in the hiring process.';
      }

      if (this.hasOpenJobs && !this.hasApplications && this.accountType !== 'basic') {
        return 'Important info to help you make decisions and hire with confidence.';
      }

      if (this.hasOpenJobs && this.hasApplications) {
        return 'Learn about the different types of checks and how they work.';
      }

      return 'Our dedicated Trust & Safety team is here to support you.';
    },
    cardLink(): string {
      if (this.hasOpenJobs && !this.hasApplications) {
        return '/trust-and-safety/parents';
      }

      if (this.hasOpenJobs && this.hasApplications) {
        return '/background-checks/whats-covered';
      }

      return '/trust-and-safety/';
    },
  },
};
</script>
